'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EmailErrorMessage = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _DefaultString = require('../../helpers/DefaultString');

var _auth = require('../../redux/modules/auth');

var _popup = require('../../redux/modules/popup');

var _EmailInput = require('./EmailInput.scss');

var _EmailInput2 = _interopRequireDefault(_EmailInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validator = require('email-validator');

var EmailErrorMessage = exports.EmailErrorMessage = {
  EmailExists: _DefaultString.translations.EmailExistsMessage,
  InvalidEmail: _DefaultString.translations.InvalidEmailMessage
};

var EmailInput = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    email: state.auth.email, error: state.auth.emailErrorMessage };
}, { addAllPopupType: _popup.addAllPopupType, editEmail: _auth.editEmail, editEmailMessageError: _auth.editEmailMessageError }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(EmailInput, _Component);

  function EmailInput() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EmailInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EmailInput.__proto__ || (0, _getPrototypeOf2.default)(EmailInput)).call.apply(_ref, [this].concat(args))), _this), _this.handleUsernameChange = function (event) {
      _this.props.editEmail(event.target.value);

      if (_this.props.handleOnChange) {
        _this.props.handleOnChange();
      }
      if (_this.props.error) {
        // Reset Error State
        _this.props.editEmailMessageError(null);
      }
      if (event.target.value === 'test_popups') {
        _this.props.addAllPopupType();
      }
    }, _this.handleOnBlur = function (event) {
      var email = event.target.value.trim();
      if (email) {
        if (_this.validateEmail(email) && _this.props.handleParentOnBlur !== undefined) {
          _this.props.handleParentOnBlur(email);
        }
      }
    }, _this.validateEmail = function (email) {
      var isEmailValid = validator.validate(email);
      _this.props.editEmailMessageError(!isEmailValid ? EmailErrorMessage.InvalidEmail : null);
      return isEmailValid;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EmailInput, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.editEmailMessageError(null);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          error = _props.error,
          email = _props.email;
      var formatMessage = this.props.intl.formatMessage;

      var inputClassName = _EmailInput2.default.email + (error ? ' ' + _EmailInput2.default.error : '') + (className ? ' ' + className : '');
      return _react2.default.createElement(
        'div',
        { className: inputClassName },
        error ? _react2.default.createElement(
          'div',
          { className: _EmailInput2.default.errorMessage },
          _react2.default.createElement(_reactIntl.FormattedMessage, error)
        ) : '',
        _react2.default.createElement(_reactBootstrap.FormControl, {
          className: _EmailInput2.default.textInput,
          name: 'username',
          type: 'email',
          defaultValue: email,
          placeholder: formatMessage(this.props.placeholder),
          onChange: this.handleUsernameChange,
          onKeyPress: this.props.handleEnterKey,
          onBlur: this.handleOnBlur
        })
      );
    }
  }]);
  return EmailInput;
}(_react.Component), _class2.propTypes = {
  addAllPopupType: _react.PropTypes.func,
  className: _react.PropTypes.string,
  email: _react.PropTypes.string,
  editEmail: _react.PropTypes.func,
  editEmailMessageError: _react.PropTypes.func,
  error: _react.PropTypes.object,
  placeholder: _react.PropTypes.object.isRequired,
  intl: _reactIntl.intlShape.isRequired,
  handleEnterKey: _react.PropTypes.func,
  handleOnChange: _react.PropTypes.func,
  handleParentOnBlur: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = EmailInput;


//////////////////
// WEBPACK FOOTER
// ./src/components/EmailInput/EmailInput.js
// module id = 408
// module chunks = 0